import React from "react";
import { Container } from "react-bootstrap";
import Seo from "../components/Seo/Seo";
import "./styles/legal.css";

const MentionsLegales = () => {
  return (
    <Container className="legal--main">
      <Seo
        title="Mentions légales | Makni Renov' - Rénovation Paris 12"
        description="Mentions légales du site maknirenov.com : éditeur, hébergeur, assurance décennale et médiation de la consommation de Makni Renov', entreprise de rénovation à Paris 12."
        path="/mentions-legales"
      />
      <h1>Mentions légales</h1>

      <h2>Éditeur du site</h2>
      <p>
        Le site maknirenov.com est édité par la société MAKNI, nom commercial
        Makni Renov', société par actions simplifiée (SAS) au capital de
        7&nbsp;500&nbsp;€.
      </p>
      <ul>
        <li>Siège social : 101 boulevard Poniatowski, 75012 Paris</li>
        <li>RCS Paris 484 561 485</li>
        <li>SIRET : 484 561 485 00034</li>
        <li>TVA intracommunautaire : FR78484561485</li>
        <li>Téléphone : 01 30 25 58 80 / 06 31 35 48 80</li>
        <li>Email : maknirenov@gmail.com</li>
      </ul>

      <h2>Directeur de la publication</h2>
      <p>M. Wissem Makni, en qualité de Président.</p>

      <h2>Hébergeur</h2>
      <p>
        GitHub, Inc. (GitHub Pages), 88 Colin P. Kelly Jr. Street, San
        Francisco, CA 94107, États-Unis.
      </p>

      <h2>Assurance professionnelle</h2>
      <p>
        Makni Renov' est assurée en responsabilité civile décennale auprès d'AXA
        France, 313 Terrasses de l'Arche, 92727 Nanterre Cedex, contrat n°
        0000022064494004, couvrant les travaux réalisés en France
        métropolitaine.
      </p>

      <h2>Médiation de la consommation</h2>
      <p>
        Conformément à l'article L612-1 du Code de la consommation, tout client
        consommateur peut recourir gratuitement à un médiateur de la
        consommation en cas de litige non résolu avec Makni Renov'. Le client
        doit d'abord adresser une réclamation écrite à l'entreprise.
      </p>
      <p>
        Médiateur : MEDICYS, 73 boulevard de Clichy, 75009 Paris,{" "}
        <a href="https://www.medicys.fr" target="_blank" rel="noreferrer">
          www.medicys.fr
        </a>
        .
      </p>

      <h2>Propriété intellectuelle</h2>
      <p>
        L'ensemble des contenus du site (textes, photographies, logo, plans) est
        la propriété de Makni Renov', sauf mention contraire. Toute
        reproduction, même partielle, sans autorisation écrite est interdite.
      </p>

      <h2>Responsabilité</h2>
      <p>
        Makni Renov' s'efforce de fournir des informations exactes et à jour.
        Les informations du site sont données à titre indicatif et ne
        constituent pas une offre contractuelle : seul le devis signé engage
        l'entreprise.
      </p>

      <h2>Liens externes</h2>
      <p>
        Le site contient des liens vers des services tiers (Facebook, Google
        Maps). Makni Renov' n'est pas responsable de leur contenu.
      </p>

      <h2>Conception du site</h2>
      <p>Mahdi AYADI.</p>
    </Container>
  );
};

export default MentionsLegales;
